import {
    buildSchema,
} from "@camberi/firecms";

const settingSchema = buildSchema({
    name: "settings",
    properties: {
        welcome_note: {
            dataType: "string",
            title: "welcome_note",
            validation: {
                required: true
            },
            config: {
                multiline: true,
            }
        },
        terms_and_conditions: {
            dataType: "string",
            title: "terms_and_conditions",
            validation: {
                required: true
            },
            config: {
                multiline: true,
            }
        },

        about: {
            dataType: "string",
            title: "About",
            validation: {
                required: true
            },
            config: {
                multiline: true,
            }


        },
        more_about: {
            dataType: "string",
            title: "About More",
            validation: {
                required: true
            },
            config: {
                multiline: true,
            }


        },
        membership_details: {
            dataType: "string",
            title: "Membership Details",
            validation: {
                required: true
            },
            config: {
                multiline: true,
            }

        },
        zenpro_benifits: {
            dataType: "string",
            title: "ZenPro Benifits",
            validation: {
                required: true
            },
            description: "ZenPro Benifits. This will display in package purchase page",
            config: {
                multiline: true,
            }
        },

        privacy_policy: {
            title: "Privacy Policy",
            dataType: "string",
            validation: {
                required: true
            },
            config: {
                multiline: true,
            }

        },
        referral_discount: {
            dataType: "string",
            title: "Referral Discount",
            validation: {
                required: true
            },

        },
        cover: {
            title: "Welcome Cover",
            dataType: "string",
            validation: {
                required: true,
            },
            config: {
                storageMeta: {
                    mediaType: "image",
                    storagePath: "images",
                    acceptedFiles: ["image/*"],
                    storeUrl: true,
                }
            }
        },
        file: {
            title: "Welcome Audio",
            dataType: "string",
            description: "Music file for welcome box",
            validation: {
                required: true,
            },
            config: {
                storageMeta: {
                    mediaType: "audio",
                    storagePath: "audio",
                    acceptedFiles: ["audio/*"],
                    storeUrl: true,
                },
            }
        },

    }
});

settingSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default settingSchema;